"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanEventModal = void 0;
/* eslint-disable react/no-multi-comp */
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const polaris_1 = require("@shopify/polaris");
const ScanEventInfo_1 = require("components/Dashboard/OrderDetails/ShipmentCards/ScanEventInfo");
const ScanEventSection = ({ scanEvent }) => {
    return (react_1.default.createElement(polaris_1.Modal.Section, { flush: true },
        react_1.default.createElement(polaris_1.Box, { padding: '300' },
            react_1.default.createElement(ScanEventInfo_1.ScanEventInfo, { scanEvent: scanEvent }))));
};
const ScanEventModal = ({ handleToggleModal, scanEvents, showModal }) => {
    const sortedEvents = (0, react_1.useMemo)(() => [...scanEvents].sort(function (a, b) {
        return (0, moment_1.default)(b.scannedAt).diff((0, moment_1.default)(a.scannedAt));
    }), [scanEvents]);
    return (react_1.default.createElement(polaris_1.Modal, { instant: true, onClose: handleToggleModal, open: showModal, title: 'Shipment History' },
        react_1.default.createElement("div", { role: 'table' }, sortedEvents.map((scanEvent, index) => (react_1.default.createElement(ScanEventSection, { key: `scan-event:${index}`, scanEvent: scanEvent }))) || null)));
};
exports.ScanEventModal = ScanEventModal;
